import { IntelligenceEntityType } from '../types'
import isAssignee from './isAssignee'
import isFirm from './isFirm'

const isAssigneeOrFirm = (entity: IntelligenceEntityType) => {
  return isFirm(entity) || isAssignee(entity)
}

export default isAssigneeOrFirm
